import { useState } from 'react';
import { cn, predefinedTags, randomColorGenerator } from 'src/utils';
import { getTagStyle, tagVariants } from './tagVariants';

type Props = {
  tag: string;
  handleOpen?: () => void;
  addGlobalTag?: (tag: string) => void;
  cartId?: string;
};

export const BaseCartTag = ({
  tag,
  handleOpen,
  addGlobalTag,
  cartId,
}: Props) => {
  const [isHovered, setIsHovered] = useState<boolean>(false);

  const lowerCaseTag = tag.toLowerCase();
  const tagStyle = getTagStyle(tag);

  // Determine if this is a predefined tag
  const isPredefinedTag = predefinedTags.some((predefinedTag) =>
    lowerCaseTag.includes(predefinedTag.toLowerCase()),
  );

  // Generate random colors for non-predefined tags
  let lightColor, darkColor;
  if (!isPredefinedTag) {
    [lightColor, darkColor] = randomColorGenerator(lowerCaseTag);
  }

  const handleClickGlobalTag = (e: React.MouseEvent) => {
    const tag = e.currentTarget.id;
    addGlobalTag && addGlobalTag(tag);
  };

  return (
    <li
      id={tag}
      onClick={
        handleOpen
          ? handleOpen
          : addGlobalTag
            ? handleClickGlobalTag
            : undefined
      }
      {...(lightColor
        ? {
            style: {
              background: lightColor,
              color: darkColor,
              fill: darkColor,
              ...(isHovered && { border: `1px solid ${darkColor}` }),
            },
            onMouseEnter: () => setIsHovered(true),
            onMouseLeave: () => setIsHovered(false),
          }
        : {})}
      className={cn(tagVariants({ status: tagStyle }))}
    >
      {tag}
    </li>
  );
};
